/* team-store-qty-grid.js — Multi-size order form for team store products.
   Each size = separate variant with its own price. Adds all selected sizes to cart at once. */
(function(){
  var spCss=document.createElement("style");
  spCss.textContent='.shopify-payment-button,.dynamic-checkout__content,[data-shopify="dynamic-checkout-cart"],.variant-picker,.product-form__input--pill{display:none !important}';
  document.head.appendChild(spCss);

  var ins=document.querySelectorAll('.ts-sz-inp');
  if(!ins.length)return;

  var tot=document.getElementById('ts-tot');
  var err=document.getElementById('ts-err');
  var origFetch=window.fetch;

  function getTotal(){var s=0;ins.forEach(function(i){s+=parseInt(i.value)||0;});return s;}

  function updateTotal(){
    var s=getTotal();
    if(tot)tot.textContent=s;
    if(err)err.style.display='none';
  }

  ins.forEach(function(i){
    i.addEventListener('input',updateTotal);
    i.addEventListener('change',updateTotal);
    /* Prevent negative values */
    i.addEventListener('blur',function(){if(parseInt(this.value)<0||isNaN(parseInt(this.value)))this.value=0;updateTotal();});
  });

  function buildCartItems(){
    var items=[];
    ins.forEach(function(inp){
      var q=parseInt(inp.value)||0;
      if(q<=0)return;
      var vid=inp.getAttribute('data-variant-id');
      if(!vid)return;
      items.push({id:parseInt(vid),quantity:q});
    });
    return items;
  }

  function addToCart(){
    var items=buildCartItems();
    if(!items.length)return;
    var btn=document.querySelector("button[name='add'],.add-to-cart");
    if(btn){btn.innerHTML='Adding...';btn.disabled=true;}

    origFetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items})
    })
    .then(function(r){return r.json();})
    .then(function(){
      if(btn)btn.innerHTML='\u2713 Added to Cart!';
      window.location.href='/cart';
    })
    .catch(function(e){
      console.error('Cart add failed:',e);
      if(btn){btn.innerHTML='Add to Cart';btn.disabled=false;}
    });
  }

  /* Intercept add-to-cart clicks */
  document.querySelectorAll("button[name='add'],.add-to-cart").forEach(function(btn){
    btn.addEventListener('click',function(e){
      var s=getTotal();
      if(s<1){
        e.preventDefault();e.stopImmediatePropagation();
        if(err){err.style.display='block';err.scrollIntoView({behavior:'smooth',block:'center'});}
        return false;
      }
      e.preventDefault();e.stopImmediatePropagation();
      addToCart();
    },true);
  });

  /* Intercept form submit */
  document.querySelectorAll("form[action*='/cart/add']").forEach(function(f){
    f.addEventListener('submit',function(e){
      var s=getTotal();
      if(s<1){
        e.preventDefault();e.stopImmediatePropagation();
        if(err){err.style.display='block';err.scrollIntoView({behavior:'smooth',block:'center'});}
        return false;
      }
      e.preventDefault();e.stopImmediatePropagation();
      addToCart();
    },true);
  });

  /* Intercept Dawn's fetch to /cart/add */
  window.fetch=function(){
    var url=arguments[0];
    if(typeof url==='string'&&url.indexOf('/cart/add')!==-1&&ins.length>0){
      return Promise.resolve(new Response(JSON.stringify({items:[]}),{status:200}));
    }
    return origFetch.apply(this,arguments);
  };

  updateTotal();
})();
